// extracted by mini-css-extract-plugin
export default {"popup":"popup__4jiVn","container":"container__bkXho","img-box":"img-box__YTflu","tag-info":"tag-info__qjhB3","name":"name__SLe4c"};